// The design labs show the real start page in frames (/debug/progress-lab):
// ?demo=1 fills it with made-up progress (a level, today's quests, the next
// achievement, achievements to open, eggs), and ?land=1 draws the phone
// layout on a computer. Read once from the address.
function param(name: string): string | null {
  try { return new URLSearchParams(window.location.search).get(name); } catch { return null; }
}

export const DEMO = param("demo") === "1";
export const FORCE_LAND = param("land") === "1";
